import FastImage from 'react-native-fast-image';
import {RFValue} from 'react-native-responsive-fontsize';
import styled, {css} from 'styled-components/native';
import FontAwesome5 from 'react-native-vector-icons/FontAwesome5';

interface Check {
  check?: boolean;
}

export const Container = styled.View``;

export const PaymentTitle = styled.Text`
  font-family: ${({theme}) => theme.fonts.semibold};
  color: ${({theme}) => theme.colors.text_dark};
  font-size: ${RFValue(12)}px;

  margin-left: ${RFValue(12)}px;
`;

export const PaymentSubtitle = styled.Text`
  font-family: ${({theme}) => theme.fonts.regular};
  color: ${({theme}) => theme.colors.text};
  font-size: ${RFValue(10)}px;

  margin-left: ${RFValue(12)}px;
`;

export const PaymentInfo = styled.TouchableOpacity`
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;

export const Payment = styled.View`
  flex-direction: row;
  align-items: center;
`;

export const BrandContainer = styled.View`
  width: ${RFValue(35)}px;
  height: ${RFValue(35)}px;
  align-items: center;
  border: 2px solid ${({theme}) => theme.colors.border3};
  border-radius: ${RFValue(10)}px;
  justify-content: center;
`;

export const BrandImage = styled(FastImage)`
  width: ${RFValue(20)}px;
  height: ${RFValue(13)}px;
`;

export const PaymentMethodInfo = styled.View`
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
`;

export const CheckIcon = styled(FontAwesome5)<Check>`
  font-size: ${RFValue(16)}px;
  color: ${({theme}) => theme.colors.placeholder};

  ${({check, theme}) =>
    check &&
    css`
      color: ${theme.colors.blue};
    `}
`;
